import { SortState } from "../types";

interface SortableHeaderProps {
  label: string;
  column: string;
  sort: SortState;
  className?: string;
}

/** A clickable table header that shows the active sort direction. */
const SortableHeader = ({ label, column, sort, className }: SortableHeaderProps) => (
  <th className={className} onClick={() => sort.onSort(column)}>
    {label}
    {sort.column === column && (
      <i
        className={`ti ti-chevron-${
          sort.direction === "asc" ? "up" : "down"
        } ms-1`}
      />
    )}
  </th>
);

export default SortableHeader;
